module.exports = __webpack_public_path__ + "img/1547425255.def1ee66.jpg";